// HeroSection.jsx
import React from "react";
import { SparklesIcon } from "lucide-react";
// import "D:\Simplifyte\Website-www.simplifyte.com\src\component\security\Security.css"
import "../../component/security/Security.css";
import { SecuritySection } from "./SecuritySection";
const SparkleIcon = () => (
  <svg
    className="w-[15px] h-[15px] text-gray-600"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M12 2l2.4 7.4H22l-6.2 4.5 2.4 7.4L12 17l-6.2 4.3 2.4-7.4L2 9.4h7.6z" />
  </svg>
);

const LockIcon = () => (
  <svg
    className="w-[19px] h-[19px] text-[#4B6280]"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="3" y="11" width="18" height="11" rx="2" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </svg>
);

const EyeIcon = () => (
  <svg
    className="w-[19px] h-[19px] text-[#4B6280]"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

const CheckCircleIcon = () => (
  <svg
    className="w-[19px] h-[19px] text-[#4B6280]"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="10" />
    <polyline points="9 12 11 14 15 10" />
  </svg>
);

const stats = [
  { icon: <LockIcon />, label: "Data Protection", value: "Bank-level" },
  { icon: <EyeIcon />, label: "Control", value: "You decide" },
  { icon: <CheckCircleIcon />, label: "Uptime", value: "99.9%" },
];

export default function SecurityHeroSection() {
  return (
    <section
      className="min-h-screen flex flex-col items-center justify-center px-6 py-36 lg:py-44 text-center"
      style={{
        background:
          "radial-gradient(ellipse 80% 60% at 50% 0%, #dde8f0 0%, #eef1f5 40%, #f3f5f7 100%)",
      }}
    >
      {/* Badge */}
      {/* inline-flex items-center gap-2 bg-white border border-gray-200 rounded-full px-[18px] py-2 text-[14px]
       font-medium mb-8 text-[#093A5B] */}
      <div className="Security_Badge">
        <SparklesIcon className="text-[#093A5B]" />
        Enterprise-Grade Security &amp; Privacy
      </div>

      {/* Heading */}
      <h1 className="security_Heading">
        Your data,
        <br />
        <span className="highlight-wrapper">
          <span className="highlight-text">protected with care.</span>
          <span className="highlight-underline"></span>
        </span>
      </h1>
      {/* Subtitle */}
      <p className="security_Para">
        Secure infrastructure, protected storage, controlled access, and
        resilient operations—designed to keep your workspace data safe.
      </p>

      {/* Buttons */}
      {/* <div className="flex flex-wrap gap-3.5 justify-center mb-16">
        <a
          // inline-flex items-center justify-center bg-[#1A3F5C] text-white text-[15px] font-bold rounded-[14px] px-9 py-[17px] min-w-[180px] hover:opacity-90 transition-opacity no-underline
          href="#"
          className="Security_btn"
        >
          Talk to Sales
        </a>
        <a
          href="#"
          className="Security_btn2"
        >
          How Security Works
        </a>
      </div> */}

      {/* Stat Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-3 md:grid-cols-3 gap-3.5 w-full max-w-[740px]">
        {stats.map(({ icon, label, value }) => (
          <div
            key={label}
            className="bg-white border border-[#E2E6EC] rounded-[16px] px-5 py-[22px] flex items-center gap-3.5 text-left"
          >
            <div className="w-[42px] h-[42px] bg-[#F3F5F8] rounded-[11px] flex items-center justify-center shrink-0">
              {icon}
            </div>
            <div>
              <p className="Security_Hero_Section_label">{label}</p>
              <p className="Security_Hero_Section_value">
                {value}
              </p>
            </div>
          </div>
        ))}
      </div>
      <div className="text-sm text-gray-400 mt-8 mb-8">
        <p>
          Built with secure infrastructure, protected storage, and product-level
          access controls.
        </p>
      </div>
      <SecuritySection />
    </section>
  );
}
